export default [
  {
    title: 'Inventory',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Warehouses',
        children: [
          {
            title: 'All Warehouses',
            route: 'warehouses-list',
          },
          {
            title: 'Types',
            route: 'warehouses-types',
          },
        ],
      },
      {
        title: 'Projects',
        route: 'projects-list',
      },
      {
        title: 'Items',
        route: 'items-list',
      },
      {
        title: 'Opening Stock',
        route: '/apps/inventory/opening-stock',
      },
      {
        title: 'Internal Delivery',
        route: 'internal-delivery-list',
      },
      {
        title: 'Loss & Adjustment',
        route: 'loss-adjustment-list',
      },
      {
        title: 'Physical Stock Take',
        route: 'physical-stock-take-list',
      },
      {
        title: 'General Issuance',
        route: 'general-issuance-list',
      },
      {
        title: 'Temporary Issuance',
        route: 'temporary-issuance-list',
      },
      {
        title: 'Direct Service Delivery',
        route: 'direct-service-delivery',
      },
      {
        title: 'Services Delivery',
        route: 'services-delivery',
      },
      {
        title: 'Virtual Stock Delivery',
        route: 'virtual-stock-delivery',
      },
      {
        title: 'Inventory History',
        route: 'inventory-history',
      },
      {
        title: 'Settings',
        route: 'inventory-settings',
        icon: 'SettingsIcon',
      },
    ],
  },
];
